<app-filter-panel [quickSearchFilter]="filters.name" quickSearchPlaceholder="Nombre" (search)="search()"></app-filter-panel>

<!--
<div class="flex gap-2 cola-4">
  <span class="w-full input-field p-input-icon-right">
    <input pInputText  placeholder="Nombre" [(ngModel)]="filters.name.value" (keydown.enter)="search()" class="w-full"/>
    <i *ngIf="filters.name.value" class="pi pi-times cursor-pointer" (click)="filters.name.value = null; search()"></i>
  </span>
</div>
-->

<p-table #grid [value]="rates" [lazy]="true" (onLazyLoad)="loadData($event)" [loading]="loading" [paginator]="true"
          [rows]="25" [totalRecords]="totalRecords" [showCurrentPageReport]="true"
          currentPageReportTemplate="Mostrando de {first} a {last} de un total de {totalRecords} entradas"
          [rowsPerPageOptions]="[25,100,250]" [scrollable]="true" scrollHeight="flex" paginatorDropdownAppendTo="body">
  <ng-template pTemplate="header" let-columns>
    <tr>      
      <th pSortableColumn="name">Nombre <p-sortIcon field="name"></p-sortIcon></th>                
      <th pSortableColumn="fromDate">Desde <p-sortIcon field="fromDate"></p-sortIcon></th>                
      <th pSortableColumn="toDate">Hasta <p-sortIcon field="toDate"></p-sortIcon></th>                      
      <th width="100"></th>
    </tr>
  </ng-template>
  <ng-template pTemplate="body" let-rate let-columns="columns">
    <tr (dblclick)="edit(rate)">      
      <td>{{rate.name}}</td>                
      <td>{{rate.fromDate | date:'dd/MM/yyyy'}}</td>                
      <td>{{rate.toDate | date:'dd/MM/yyyy'}}</td>                
      <td>
        <div class="flex gap-2 justify-content-end">
          <p-button *ngIf="allowDelete" (click)="delete(rate)" [rounded]="true" [text]="false" severity="danger"><i class="pi pi-trash"></i></p-button>
          <p-button *ngIf="allowWrite" (click)="edit(rate)" [rounded]="true" [text]="false"><i class="pi pi-pencil"></i></p-button>
        </div>
      </td>
    </tr>
  </ng-template>
</p-table>

<p-confirmDialog></p-confirmDialog>